import { render, staticRenderFns } from "./productPack.vue?vue&type=template&id=298217e5&"
import script from "./productPack.vue?vue&type=script&lang=ts&"
export * from "./productPack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports